import { graphql, useStaticQuery } from 'gatsby';
import React, { FC, useContext } from 'react';

import GahtFuAppointmentSelectionStepComponent, {
	IGahtFuAppointmentSelectionStepPageContent,
} from '@ui/routes/GahtFu/GahtFuAppointmentSelectionStep/GahtFuAppointmentSelectionStep.component';

import { keysToCamel } from '@utils/butter';

import FlowContext from '@providers/FlowContextProvider';

import { IFlowStepProps } from '@folx-types/flow-steps';

interface IAppointmentSelectionStepPageProps extends IFlowStepProps {}

const GahtFuAppointmentSelectionStepPage: FC<IAppointmentSelectionStepPageProps> = ({
	path,
	stepKey,
}) => {
	const { pageContent } = useStaticQuery<Record<string, string>>(graphql`
		{
			pageContent: butterPage(slug: { eq: "member-appointment-selection" }) {
				appointment_selection_header
				appointment_selection_description
				appointment_header
				appointment_subheader
				appointment_description
				cancellation_header
				cancellation_description
				edit_label
				interpreter_info
				past_membership_cancel_date {
					header
					subheader
					description
					cta
					secondary_cta
				}
				error_messages {
					state_service_not_found
					no_prior_gaht_visit
					has_upcoming_appointment
					no_provider_found
					generic_message
				}
			}
		}
	`);

	const { existingFormData, handleFormSubmission, handleNavBack, destinationFlow } =
		useContext(FlowContext);

	const refinedContent: IGahtFuAppointmentSelectionStepPageContent = keysToCamel(
		pageContent
	) as IGahtFuAppointmentSelectionStepPageContent;

	return (
		<GahtFuAppointmentSelectionStepComponent
			destinationFlow={destinationFlow}
			pageContent={refinedContent}
			path={path}
			stepKey={stepKey}
			existingFormData={existingFormData}
			handleFormSubmission={handleFormSubmission}
			handleNavBack={handleNavBack}
		/>
	);
};

export default GahtFuAppointmentSelectionStepPage;
